import { Injectable } from '@angular/core';
import {
  CanActivate,
  Router,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  CanActivateChild,
} from '@angular/router';
import { AuthenticationService } from '../services';
import { AuthGuardParameter } from '../models';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivateChild, CanActivate {
  constructor(private router: Router, private authenticationService: AuthenticationService) {}

  canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    return this.checkActivate(route, state);
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    return this.checkActivate(route, state);
  }

  checkActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const parameter: AuthGuardParameter = route.data as AuthGuardParameter;

    if (this.authenticationService.isLoggedIn()) {
      // check permission
      if (this.authenticationService.hasPermission(parameter.roles)) {
        return true;
      }
      this.router.navigate(['./not-authorized']);
      return true;
    }
    // not logged in so redirect to login page
    this.router.navigate(['./login']);
    return false;
  }
}
